<template>
    <div :class="['dropdown', classes]">
        <slot></slot>
    </div>
</template>

<script setup>
// Define props
const props = defineProps({
    classes: {
        type: String,
        default: ""
    }
});
</script>

<style scoped>
.dropdown {
    @apply relative;
}
.dropdown :deep(ul:not(.label_dropdown__list)) {
    @apply shadow-dropdown dark:shadow-dropdownDark bg-white dark:bg-dark-100 p-4 min-w-[18rem] sm:min-w-[20rem] rounded-lg max-h-[calc(100vh-120px)] overflow-y-auto;
}
.dropdown :deep(ul li:not(.label_dropdown__item)) {
    @apply cursor-pointer flex items-center py-[0.6875rem] px-2 dark:text-white dark:bg-black-900 hover:bg-gray-100 hover:rounded-lg;
}

.dropdown :deep(ul li:last-of-type) {
    @apply border-b-0;
}

.dropdown :deep(ul li svg) {
    @apply text-gray-300 ltr:mr-2 rtl:ml-2 text-xl;
}

.dropdown :deep(ul li span:not(.step_title):not(.badge)) {
    @apply text-dark-100 dark:text-white text-sm font-light;
}

.progress_dropdown {
    @apply max-h-[33vh] overflow-y-auto;
}
</style>
